/**
 * @param {import('next').NextConfig} nextConfig
 */
const rssFeedPlugin = (nextConfig = {}) => {
    return {
        ...nextConfig,
        async rewrites() {
            return [
                ...(await nextConfig.rewrites()),
                // rss route
                {
                    source: "/rss.xml",
                    destination: "/api/rss",
                },
            ];
        },
    };
};

module.exports = rssFeedPlugin;
